(function () {
  if (window.__afCardAdd) return;
  window.__afCardAdd = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('button[data-af-card-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;

    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender
      ? drawer.getSectionsToRender().map(function (x) { return x.section; }).join(',')
      : '';
    var base = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

    btn.disabled = true;
    btn.classList.add('is-loading');

    var payload = { items: [{ id: parseInt(btn.getAttribute('data-af-card-add'), 10), quantity: 1 }] };
    if (sections) {
      payload.sections = sections;
      payload.sections_url = window.location.pathname;
    }

    fetch(base + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status || res.errors) { return; }
        if (drawer && res.sections) {
          drawer.renderContents(res, true);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
        }
        if (typeof updateCartCounters === 'function') updateCartCounters();
      })
      .catch(function () {})
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });
})();
